import { Controller } from "stimulus"

export default class extends Controller {
  static get targets() {
    return ["button", "tooltip"]
  }

  async share() {
    const shareData = {
      title: this.buttonTarget.dataset.title,
      url: this.buttonTarget.dataset.url
    }

    if (navigator.share) {
      navigator.share(shareData)
        .catch(console.error)
    } else {
      //Fallback method
      this.copyToClipboard(shareData.url)
    }
  }

  copyToClipboard(url) {
    navigator.clipboard.writeText(url)
      .then(() => {
        this.showTooltip()
      })
      .catch(console.error)
  }

  showTooltip() {
    this.tooltipTarget.classList.remove("tw-hidden")
    setTimeout(() => {
      this.tooltipTarget.classList.add("tw-hidden")
    }, 2000);
  }

}
